"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1926,8084,713],{

/***/ 51926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HierarchyUtils; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89554);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49337);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(33321);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69070);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(930);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_classCallCheck_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(33227);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_classCallCheck_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_classCallCheck_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_createClass_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(88361);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_createClass_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_createClass_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(21249);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(82772);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(68309);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(15306);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(67294);
/* harmony import */ var _components_Icon_Icon__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(80713);
/* harmony import */ var _components_Image_Image__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(48084);
/* harmony import */ var _components_LanguageSelection_LanguageSelection__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(88565);
/* harmony import */ var _adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(8996);
/* harmony import */ var _components_LoginNavigationBlock_LoginNavigationBlock__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(39824);
/* harmony import */ var _pagespeedHelper__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(19271);
/* harmony import */ var _Constants__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(24036);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(85893);














function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_10___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



















var HierarchyUtils = /*#__PURE__*/function () {
  function HierarchyUtils() {
    _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_classCallCheck_js__WEBPACK_IMPORTED_MODULE_11___default()(this, HierarchyUtils);
  }

  _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_createClass_js__WEBPACK_IMPORTED_MODULE_12___default()(HierarchyUtils, null, [{
    key: "getLevel",
    value: function getLevel(hierarchyDoc) {
      var _hierarchyDoc$fields;

      if (!(hierarchyDoc == null ? void 0 : (_hierarchyDoc$fields = hierarchyDoc.fields) == null ? void 0 : _hierarchyDoc$fields.level)) {
        return;
      }

      return hierarchyDoc.fields.level;
    }
  }, {
    key: "renderHierarchy",
    value: function renderHierarchy(hierarchy) {
      var _this = this;

      var destinations = hierarchy.fields.destinations;
      var title = hierarchy.fields.title;
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__.jsxs)("div", {
        children: [title && this.renderHierarchyTitle(hierarchy, title), destinations && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__.jsx)("ul", {
          id: this.getHierarchyId(hierarchy),
          children: destinations.map(function (d, index) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__.jsx)("li", {
              children: _this.renderDestination(d)
            }, index);
          })
        })]
      });
    }
  }, {
    key: "renderDestination",
    value: function renderDestination(dest) {
      var _dest$fields;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var icon = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var onClick = arguments.length > 3 ? arguments[3] : undefined;
      var className = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var privacyLink = arguments.length > 5 ? arguments[5] : undefined;
      var type = dest == null ? void 0 : (_dest$fields = dest.fields) == null ? void 0 : _dest$fields.contentType;

      switch (type) {
        case 'pageLink':
          return this.renderPageLink(dest, icon, onClick, className);

        case 'hierarchy':
          dest.fields.level = 'child';
          return callback ? callback() : this.renderHierarchy(dest);

        case 'link':
          return this.renderLink(dest, icon, onClick, className, privacyLink);

        case 'languageSelectionBlock':
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__.jsx)(_components_LanguageSelection_LanguageSelection__WEBPACK_IMPORTED_MODULE_21__["default"], _objectSpread({}, dest));

        case 'loginNavigationBlock':
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__.jsx)(_components_LoginNavigationBlock_LoginNavigationBlock__WEBPACK_IMPORTED_MODULE_23__["default"], {
            document: dest
          });

        default:
          return 'Unsupported Type : ' + type;
      }
    }
  }, {
    key: "renderPageLink",
    value: function renderPageLink(pageLink) {
      var _pageLink$fields, _pageLink$fields$page, _pageLink$fields$page2;

      var icon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var onClick = arguments.length > 2 ? arguments[2] : undefined;
      var className = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var link = pageLink == null ? void 0 : (_pageLink$fields = pageLink.fields) == null ? void 0 : (_pageLink$fields$page = _pageLink$fields.pagePath) == null ? void 0 : (_pageLink$fields$page2 = _pageLink$fields$page.fields) == null ? void 0 : _pageLink$fields$page2.slug;
      return this.renderLinkAndTitle(pageLink.fields, link, icon, onClick, className);
    }
  }, {
    key: "renderLink",
    value: function renderLink(link) {
      var _link$fields, _link$fields2, _link$fields3;

      var icon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var onClick = arguments.length > 2 ? arguments[2] : undefined;
      var className = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var privacyLinkObj = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      var url = (link == null ? void 0 : (_link$fields = link.fields) == null ? void 0 : _link$fields.url) === _Constants__WEBPACK_IMPORTED_MODULE_25__/* .Constants.PrivacyLinkPlaceholder */ .gT.PrivacyLinkPlaceholder ? (privacyLinkObj == null ? void 0 : privacyLinkObj.privacy) || (link == null ? void 0 : (_link$fields2 = link.fields) == null ? void 0 : _link$fields2.fallBackUrl) : link == null ? void 0 : (_link$fields3 = link.fields) == null ? void 0 : _link$fields3.url;
      return this.renderLinkAndTitle(link.fields, url, icon, onClick, className);
    }
  }, {
    key: "renderLinkAndTitle",
    value: function renderLinkAndTitle(link, url) {
      var icon = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var onClick = arguments.length > 3 ? arguments[3] : undefined;
      var className = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var classNames = '';

      if (link == null ? void 0 : link.linkClassName) {
        classNames = link == null ? void 0 : link.linkClassName;
      }

      if (className) {
        classNames += " ".concat(className);
      }

      var currentPage = className && className.indexOf('is-active') > -1 ? true : false;
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__.jsxs)("a", {
        href: url,
        "data-action-detail": (0,_adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_22__/* .stripHtml */ .Vt)(link.dataActionDetail ? link.dataActionDetail : link.title),
        "aria-label": (0,_adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_22__/* .stripHtml */ .Vt)(link.ariaLabel ? link.ariaLabel : link.title),
        onClick: onClick,
        target: (link == null ? void 0 : link.type) === 'external' ? '_blank' : undefined,
        rel: (link == null ? void 0 : link.type) === 'external' ? 'noopener noreferrer' : undefined,
        className: classNames,
        children: [link.image && this.renderImage(link.image, link), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__.jsxs)("span", {
          children: [icon && icon.position === 'before' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__.jsx)(_components_Icon_Icon__WEBPACK_IMPORTED_MODULE_19__["default"], _objectSpread({}, icon)), currentPage ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__.jsx)("span", {
            "aria-current": 'page',
            dangerouslySetInnerHTML: {
              __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_26___default().sanitize(link.title)
            }
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__.Fragment, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__.jsx)("span", {
              dangerouslySetInnerHTML: {
                __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_26___default().sanitize(link.title)
              }
            }), link.largeTitle && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__.jsx)("span", {
              className: "largeTitle",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__.jsx)("span", {
                dangerouslySetInnerHTML: {
                  __html: link.largeTitle
                }
              })
            })]
          }), icon && (icon.position === 'after' || icon.position === '') && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__.jsx)(_components_Icon_Icon__WEBPACK_IMPORTED_MODULE_19__["default"], _objectSpread({}, icon))]
        })]
      });
    }
  }, {
    key: "renderImage",
    value: function renderImage(image, link) {
      var _image$fields, _image$fields$asset, _image$fields$asset$f, _image$fields$asset$f2;

      var handleMouseOver = function handleMouseOver(event, image) {
        event.currentTarget.src = image;
      };

      var handleMouseOut = function handleMouseOut(event, image) {
        event.currentTarget.src = image;
      };

      return (link == null ? void 0 : link.isPopupImageNeed) ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__.jsx)("div", {
        className: "ob-mainAsset-wrapper",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__.jsx)("img", {
          className: "ob-mainAsset-wrapper-img",
          src: (0,_pagespeedHelper__WEBPACK_IMPORTED_MODULE_24__/* .optimizeImage */ .H)(image == null ? void 0 : (_image$fields = image.fields) == null ? void 0 : (_image$fields$asset = _image$fields.asset) == null ? void 0 : (_image$fields$asset$f = _image$fields$asset.fields) == null ? void 0 : (_image$fields$asset$f2 = _image$fields$asset$f.file) == null ? void 0 : _image$fields$asset$f2.url),
          "aria-hidden": true,
          height: 150,
          width: 150,
          onMouseOver: function onMouseOver(event) {
            var _link$hoverImage, _link$hoverImage$fiel, _link$hoverImage$fiel2, _link$hoverImage$fiel3, _link$hoverImage$fiel4;

            return handleMouseOver(event, link == null ? void 0 : (_link$hoverImage = link.hoverImage) == null ? void 0 : (_link$hoverImage$fiel = _link$hoverImage.fields) == null ? void 0 : (_link$hoverImage$fiel2 = _link$hoverImage$fiel.asset) == null ? void 0 : (_link$hoverImage$fiel3 = _link$hoverImage$fiel2.fields) == null ? void 0 : (_link$hoverImage$fiel4 = _link$hoverImage$fiel3.file) == null ? void 0 : _link$hoverImage$fiel4.url);
          },
          onMouseOut: function onMouseOut(event) {
            var _image$fields2, _image$fields2$asset, _image$fields2$asset$, _image$fields2$asset$2;

            return handleMouseOut(event, image == null ? void 0 : (_image$fields2 = image.fields) == null ? void 0 : (_image$fields2$asset = _image$fields2.asset) == null ? void 0 : (_image$fields2$asset$ = _image$fields2$asset.fields) == null ? void 0 : (_image$fields2$asset$2 = _image$fields2$asset$.file) == null ? void 0 : _image$fields2$asset$2.url);
          }
        })
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__.jsx)(_components_Image_Image__WEBPACK_IMPORTED_MODULE_20__["default"], {
        noLazyLoad: true,
        image: image,
        ariaHidden: true
      });
    }
  }, {
    key: "getHierarchyId",
    value: function getHierarchyId(hierarchyDoc) {
      var _hierarchyDoc$fields2, _id;

      var id = hierarchyDoc == null ? void 0 : (_hierarchyDoc$fields2 = hierarchyDoc.fields) == null ? void 0 : _hierarchyDoc$fields2.name;
      id = (_id = id) == null ? void 0 : _id.replace(/ /g, '-');
      return id;
    }
  }, {
    key: "renderHierarchyTitle",
    value: function renderHierarchyTitle(hierarchy, title) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__.jsx)("div", {
        dangerouslySetInnerHTML: {
          __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_26___default().sanitize(title)
        }
      });
    }
  }]);

  return HierarchyUtils;
}();



/***/ }),

/***/ 19271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ optimizeImage; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26699);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32023);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_1__);


var optimizeImage = function optimizeImage(imageUrl, imageFormatValue, imageQualityValue) {
  var imageFormat = imageFormatValue ? imageFormatValue : 'webp';
  var imageQuality = imageQualityValue ? imageQualityValue : 85;

  if (imageUrl !== undefined && imageUrl !== null && imageUrl.includes('images.ctfassets.net') && imageUrl.includes('fm=webp') == false && imageUrl.includes('.svg') == false) {
    var _imageUrl;

    if ((_imageUrl = imageUrl) == null ? void 0 : _imageUrl.includes('https')) {
      var _imageUrl2;

      if ((_imageUrl2 = imageUrl) == null ? void 0 : _imageUrl2.includes('?')) {
        imageUrl = imageUrl + "&fm=".concat(imageFormat) + "&q=".concat(imageQuality);
      } else {
        imageUrl = imageUrl + "?fm=".concat(imageFormat) + "&q=".concat(imageQuality);
      }
    } else {
      var _imageUrl3;

      imageUrl = 'https:' + imageUrl;

      if ((_imageUrl3 = imageUrl) == null ? void 0 : _imageUrl3.includes('?')) {
        imageUrl = imageUrl + "&fm=".concat(imageFormat) + "&q=".concat(imageQuality);
      } else {
        imageUrl = imageUrl + "?fm=".concat(imageFormat) + "&q=".concat(imageQuality);
      }
    }
  }

  return imageUrl;
};

/***/ }),

/***/ 80713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Icon_Icon; }
});

// NAMESPACE OBJECT: ./components/Icon/icons.js
var icons_namespaceObject = {};
__webpack_require__.r(icons_namespaceObject);
__webpack_require__.d(icons_namespaceObject, {
  "arrowLeft": function() { return arrowLeft; },
  "arrowRight": function() { return arrowRight; },
  "chevronDown": function() { return chevronDown; },
  "chevronLeft": function() { return chevronLeft; },
  "chevronRight": function() { return chevronRight; },
  "chevronTop": function() { return chevronTop; },
  "close": function() { return icons_close; },
  "fullChevronDown": function() { return fullChevronDown; },
  "hamburger": function() { return hamburger; },
  "icon360": function() { return icon360; },
  "minus6": function() { return minus6; },
  "ovalArrowRight": function() { return ovalArrowRight; },
  "play": function() { return play; },
  "plus": function() { return plus; },
  "plus6": function() { return plus6; },
  "search": function() { return search; },
  "spotlightPause": function() { return spotlightPause; },
  "spotlightPlay": function() { return spotlightPlay; },
  "spotlightReplay": function() { return spotlightReplay; },
  "spotlightTranscript": function() { return spotlightTranscript; },
  "star": function() { return star; },
  "starEmpty": function() { return starEmpty; },
  "starHalf": function() { return starHalf; },
  "thinChevronDown": function() { return thinChevronDown; },
  "wideChevronDown": function() { return wideChevronDown; }
});

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(92222);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/Icon/icons.js
var chevronRight = '<path d="M12 1 L26 16 L12 31 L8 27 L18 16 L8 5 z"></path>';
var chevronDown = '<path d="M12 1 L26 16 L12 31 L8 27 L18 16 L8 5 z"></path>';
var chevronLeft = '<path d="M12 1 L26 16 L12 31 L8 27 L18 16 L8 5 z"></path>';
var chevronTop = '<path d="M12 1 L26 16 L12 31 L8 27 L18 16 L8 5 z"></path>';
var hamburger = '<path d="M0.8,0 L31.2,0 C31.6418278,0 32,0.477562934 32,1.06666667 C32,1.6557704 31.6418278,2.13333333 31.2,2.13333333 L0.8,2.13333333 C0.3581722,2.13333333 0,1.6557704 0,1.06666667 L0.8,0 Z M0.8,29.8666667 L31.2,29.8666667 C31.6418278,29.8666667 32,30.3442296 32,30.9333333 C32,31.5224371 31.6418278,32 31.2,32 L0.8,32 C0.3581722,32 0,31.5224371 0,30.9333333 L0.8,29.8666667 Z M0.8,14.9333333 L31.2,14.9333333 C31.6418278,14.9333333 32,15.4108963 32,16 C32,16.5891037 31.6418278,17.0666667 31.2,17.0666667 L0.8,17.0666667 C0.3581722,17.0666667 0,16.5891037 0,16 L0.8,14.9333333 Z"></path>';
var icons_close = '<polygon points="30.3,31.7 16,17.4 1.7,31.7 0.3,30.3 14.6,16 0.3,1.7 1.7,0.3 16,14.6 30.3,0.3 31.7,1.7 17.4,16 31.7,30.3"/>';
var search = '<path d="M20.8472613,19.185011 C24.6648695,14.5843036 24.3712073,7.83007361 20.0641621,3.52302839 C17.9106395,1.36950578 14.9740178,0.096969697 11.8416213,0.096969697 L11.7437339,0.096969697 C8.70922474,0.096969697 5.772603,1.27161839 3.61908039,3.425141 C1.46555779,5.57866361 0.290909091,8.51528535 0.290909091,11.6476819 C0.290909091,14.7800784 1.56344518,17.6188127 3.71696779,19.8702227 C8.024013,24.1772679 14.6803556,24.4709301 19.3789504,20.6533219 L29.8529013,31.1272727 L31.3212121,29.6589619 M18.6937386,19.9681101 C14.4845808,23.4920562 8.31767517,23.198394 4.40217952,19.185011 C2.34654431,17.1293758 1.269783,14.4864162 1.269783,11.6476819 C1.269783,8.80894752 2.34654431,6.16598796 4.30429213,4.11035274 C6.26203996,2.15260491 8.90499952,1.07584361 11.7437339,1.07584361 L11.8416213,1.07584361 C14.6803556,1.07584361 17.3233152,2.2504923 19.3789504,4.20824013 C23.294446,8.12373578 23.5881082,14.2906414 20.1620495,18.4997993 L19.5747252,19.185011 L19.4768378,19.2828984"></path>';
var arrowLeft = '<polygon class="st0" points="32,16.9 3.3,16.9 14.7,28.2 13.5,29.5 1.2,17.2 0,16 13.5,2.5 14.7,3.8 3.3,15.1 32,15.1 "/>';
var arrowRight = '<polygon class="st0" points="32,16.9 3.3,16.9 14.7,28.2 13.5,29.5 1.2,17.2 0,16 13.5,2.5 14.7,3.8 3.3,15.1 32,15.1 "/>';
var ovalArrowRight = '<path d="M16,0 C7.2,0 0,7.2 0,16 C0,24.8 7.2,32 16,32 C24.8,32 32,24.8 32,16 C32,7.2 24.8,0 16,0 Z M14.5,21.4 L12.9,19.8 L16.6,16 L12.9,12.2 L14.5,10.6 L19.9,16 L14.5,21.4 Z"></path>';
var wideChevronDown = '<polygon class="st0" points="15,17.1 0,6.9 4.7,0 15,6.9 25.3,0 30,6.9 "/>';
var fullChevronDown = '<polygon transform="rotate(90 189.5 -153.5)" points="349 30 343 36 343 24" fill="#3D3D41" fill-rule="evenodd"/>';
var thinChevronDown = '<polygon points="16,24.4 0,8.4 0.8,7.6 16,22.9 31.2,7.6 32,8.4 "/>';
var play = '<path d="M15.7,31.4C7,31.4,0,24.4,0,15.7S7,0,15.7,0s15.7,7,15.7,15.7S24.4,31.4,15.7,31.4z M15.7,30.9c8.4,0,15.2-6.8,15.2-15.2 S24.1,0.5,15.7,0.5S0.5,7.3,0.5,15.7S7.3,30.9,15.7,30.9z M14.5,11.9l3.8,3.8l-3.8,3.8V11.9z" />';
var plus = '<path d="M10 5.5H5.5V10h-1V5.5H0v-1h4.5V0h1v4.5H10v1z"></path>';
var plus6 = '<path d="M3.5,2.474l2.5,0l0,1l-2.5,0l0,2.521l-1,0l0,-2.521l-2.5,0l0,-1l2.5,0l0,-2.474l1,0l0,2.474Z"></path>';
var minus6 = '<rect x="0" y="2.5" width="6" height="1" />';
var star = '<path fill="#ffb702" d="M16 26.5L6.1 32 8 20.4l-8-8.2 11.1-1.7L16 0l4.9 10.5L32 12.2l-8 8.2L25.9 32z"/>';
var starHalf = '<path d="M32 12.2l-11.1-1.7L16 0l-4.9 10.5L0 12.2l8 8.2L6.1 32l9.9-5.4 9.9 5.5L24 20.4l8-8.2zm-7 18.5l-8.2-4.6V3.4l3.7 7.7 10.3 1.5-7.4 7.5L25 30.7z" fill="#ffb702"/>';
var starEmpty = '<path d="M6.1 32L8 20.4l-8-8.2 11-1.7L16 0l5 10.5 11 1.7-8 8.2L25.9 32 16 26.5 6.1 32zm9.9-6.3l9 5-1.7-10.5 7.3-7.5-10-1.5L16 1.6l-4.5 9.6-10 1.5 7.3 7.5L7 30.7l9-5z" fill="#ffb702"/>';
var icon360 = '<defs><path d="M0 .137h52.845V26H0z"/><path d="M.35.266h6.539V6.59H.35z"/></defs><g fill="none" fill-rule="evenodd"><path d="M-5-12h63v63H-5z"/><path fill="#646464" d="M17.231 21.307l.111.586h.035l.118-.586 1.043-3.979h1.787l-2.157 6.34h-1.634l-2.157-6.34h1.788zM21.157 23.668h1.711v-6.34h-1.711v6.34zm0-7.857h1.711v-1.283h-1.711v1.283zM26.928 18.53a.892.892 0 00-.75.363c-.184.242-.297.56-.34.955l.018.03h2.097v-.153c0-.363-.085-.653-.254-.87-.17-.217-.427-.325-.77-.325m.151 5.262c-.914 0-1.644-.293-2.19-.88-.548-.585-.82-1.33-.82-2.232v-.234c0-.941.257-1.717.775-2.326.518-.61 1.212-.912 2.083-.908.855 0 1.52.257 1.992.773.473.516.71 1.213.71 2.092v.932h-3.786l-.012.035c.032.416.171.758.42 1.027.247.269.584.402 1.01.402.38 0 .693-.038.943-.114.25-.076.524-.196.821-.36l.463 1.057c-.258.212-.596.388-1.014.527a4.403 4.403 0 01-1.395.209M36.139 21.401h.035L37 17.329h1.606l-1.612 6.34h-1.429l-1.178-3.774h-.035l-1.178 3.774H31.75l-1.611-6.34h1.605l.838 4.06h.036l1.183-4.06h1.143zM20.241 4.826c0 1.448-.865 2.42-2.33 2.843 1.482.16 2.72 1.041 2.72 2.93 0 1.996-1.608 3.672-4.556 3.672-1.8 0-3.16-.67-4.096-1.8l1.5-1.465c.795.794 1.501 1.147 2.437 1.147 1.095 0 1.853-.636 1.853-1.73 0-1.254-.688-1.713-1.94-1.713h-.99l.3-1.924h.69c1.058 0 1.711-.565 1.711-1.554 0-.865-.617-1.377-1.589-1.377-.883 0-1.624.354-2.33 1.042l-1.377-1.5c1.112-1.06 2.436-1.607 4.025-1.607 2.577 0 3.972 1.36 3.972 3.036M27.953 9.929c0-1.536-.494-2.065-1.412-2.065-.636 0-1.236.335-1.748.935.035 2.489.46 3.478 1.66 3.478 1.006 0 1.5-.936 1.5-2.348m2.79-.035c0 2.435-1.66 4.378-4.326 4.378-3.16 0-4.52-2.33-4.52-5.755 0-4.043 1.96-6.727 5.191-6.727 1.13 0 2.03.335 2.72.794l-1.026 1.66c-.494-.283-1.006-.459-1.624-.459-1.342 0-2.207 1.165-2.365 3.266.741-.776 1.624-1.112 2.524-1.112 1.96 0 3.425 1.43 3.425 3.955M34.711 8.022c0 3.16.477 4.185 1.642 4.185 1.147 0 1.641-.954 1.641-4.185 0-3.248-.494-4.166-1.641-4.166-1.165 0-1.642 1.006-1.642 4.166m6.144 0c0 3.99-1.572 6.25-4.502 6.25-2.931 0-4.502-2.26-4.502-6.25 0-4.007 1.571-6.231 4.502-6.231 2.93 0 4.502 2.224 4.502 6.23"/><g transform="translate(0 13)"><mask fill="#fff"><use xlink:href="#a"/></mask><path fill="#646464" d="M36.715 14.74c6.448-1.688 10.217-4.569 10.217-7.916 0-1.377-.668-3.387-3.759-5.306V.137c6.085 2.442 9.672 5.957 9.672 9.548 0 3.433-3.23 6.778-8.882 9.22l-7.248-4.165zm-11.629 7.647l-.931-.066C10.385 21.367 0 15.934 0 9.686 0 6.453 2.866 3.297 7.923.9v1.948c-1.334 1.234-2.01 2.57-2.01 3.976 0 4.572 7.441 8.36 18.093 9.211l1.08.087v-3.704l11.82 6.791L25.086 26v-3.613z" mask="url(#b)"/></g><g transform="translate(42)"><mask fill="#fff"><use xlink:href="#c"/></mask><path fill="#646464" d="M2.288 3.446c0 .796.573 1.405 1.33 1.405.759 0 1.314-.61 1.314-1.423 0-.72-.463-1.422-1.313-1.422-.813 0-1.331.683-1.331 1.44m4.6-.04c0 1.85-1.526 3.184-3.29 3.184C1.707 6.59.352 5.191.352 3.47.33 1.685 1.79.265 3.62.265c1.936 0 3.269 1.442 3.269 3.141" mask="url(#d)"/></g></g>';
var spotlightPlay = '<path d="M7.193,5.164V26.836a2.133,2.133,0,0,0,3.357,1.748L26.03,17.748a2.133,2.133,0,0,0,0-3.5L10.55,3.416A2.133,2.133,0,0,0,7.193,5.164Z"></path>';
var spotlightPause = '<rect x="4.267" y="1.067" width="8.533" height="29.867" rx="2.133" ry="2.133"/><rect x="19.2" y="1.067" width="8.533" height="29.867" rx="2.133" ry="2.133"/>';
var spotlightReplay = '<path d="M26.066,20.708A10.3,10.3,0,0,1,21.7,27.431a9.8,9.8,0,0,1-7.481,1.5A10.522,10.522,0,0,1,6.155,16.64a10.3,10.3,0,0,1,4.369-6.722A9.779,9.779,0,0,1,17.9,8.41l-.088,7.6,7.6-7.721L17.985.74l-.064,5.539A11.9,11.9,0,0,0,9.33,8.149a12.421,12.421,0,0,0-5.273,8.1,12.666,12.666,0,0,0,9.736,14.771,12.072,12.072,0,0,0,2.4.242,11.937,11.937,0,0,0,6.693-2.06,12.414,12.414,0,0,0,5.273-8.1Z"></path>';
var spotlightTranscript = '<path d="M28.5,1H3.5A2.5,2.5,0,0,0,1,3.5v25A2.5,2.5,0,0,0,3.5,31h25A2.5,2.5,0,0,0,31,28.5V3.5A2.5,2.5,0,0,0,28.5,1ZM26,26H6V21H26Zm0-7.5H6v-5H26ZM26,11H6V6H26Z"></path>';
// EXTERNAL MODULE: ./adapters/helpers/Constants.js
var Constants = __webpack_require__(24036);
// EXTERNAL MODULE: ./adapters/helpers/Loader.js
var Loader = __webpack_require__(47322);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/Icon/Icon.js








var Icon = function Icon(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      name = _ref.name,
      viewBox = _ref.viewBox,
      ariaHidden = _ref.ariaHidden,
      size = _ref.size,
      color = _ref.color,
      rotate = _ref.rotate,
      roundedIcon = _ref.roundedIcon,
      arialable = _ref.arialable;

  if (!name) {
    return null;
  }

  var newStyle = {
    fill: color && color,
    width: size && "".concat(size, "rem"),
    height: size && "".concat(size, "rem"),
    fontSize: size && "".concat(size, "rem"),
    transform: rotate && "rotate(".concat(rotate, "deg)")
  };
  return roundedIcon ? /*#__PURE__*/(0,jsx_runtime.jsx)(react.Suspense, {
    fallback: /*#__PURE__*/(0,jsx_runtime.jsx)(Loader["default"], {}),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "".concat(Constants/* IconsConstant.obIconRoundedContainer */.Lh.obIconRoundedContainer, " -").concat(roundedIcon, " ").concat(className),
      style: newStyle,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
        className: "ob-icon ob-icon--".concat(name),
        viewBox: "0 0 ".concat(viewBox, " ").concat(viewBox),
        "aria-hidden": ariaHidden,
        dangerouslySetInnerHTML: {
          __html: icons_namespaceObject[name]
        },
        role: Constants/* IconsConstant.role */.Lh.role,
        alt: Constants/* IconsConstant.iconOne */.Lh.iconOne,
        "aria-label": arialable ? arialable : arialable === null ? '' : "ob-icon-rounded-container -".concat(roundedIcon, " ").concat(className)
      })
    })
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(react.Suspense, {
    fallback: /*#__PURE__*/(0,jsx_runtime.jsx)(Loader["default"], {}),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
      className: "ob-icon ob-icon--".concat(name, " ").concat(className),
      viewBox: "0 0 ".concat(viewBox, " ").concat(viewBox),
      "aria-hidden": ariaHidden,
      style: newStyle,
      dangerouslySetInnerHTML: {
        __html: icons_namespaceObject[name]
      },
      role: Constants/* IconsConstant.role */.Lh.role,
      alt: Constants/* IconsConstant.iconTwo */.Lh.iconTwo,
      "aria-label": arialable ? arialable : arialable === null ? '' : "ob-icon-rounded-container -".concat(roundedIcon, " ").concat(className)
    })
  });
};

Icon.defaultProps = {
  styles: {},
  viewBox: 32,
  rotate: 0
};
/* harmony default export */ var Icon_Icon = (Icon);

/***/ }),

/***/ 48084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Image; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89554);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49337);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33321);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69070);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(930);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(88674);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(92222);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(24036);
/* harmony import */ var _adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(47322);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(85893);











function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_9___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var BackgroundImage = next_dynamic__WEBPACK_IMPORTED_MODULE_14___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(9261), __webpack_require__.e(9837)]).then(__webpack_require__.bind(__webpack_require__, 89837));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(89837)];
    }
  }
});
var Img = next_dynamic__WEBPACK_IMPORTED_MODULE_14___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(4885), __webpack_require__.e(1036), __webpack_require__.e(7776), __webpack_require__.e(8996), __webpack_require__.e(9261), __webpack_require__.e(9572)]).then(__webpack_require__.bind(__webpack_require__, 7273));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(7273)];
    }
  }
});


function Image(props) {
  var _props$children = props.children,
      children = _props$children === void 0 ? null : _props$children,
      image = props.image,
      altText = props.altText,
      scale = props.scale,
      _props$customStyles = props.customStyles,
      customStyles = _props$customStyles === void 0 ? null : _props$customStyles,
      noAltText = props.noAltText,
      text = props.text,
      _props$elemId = props.elemId,
      elemId = _props$elemId === void 0 ? null : _props$elemId,
      _props$ariaHidden = props.ariaHidden,
      ariaHidden = _props$ariaHidden === void 0 ? false : _props$ariaHidden;

  if (image) {
    var _image$fields, _image$fields2, _image$fields2$asset, _image$fields2$asset$, _image$fields2$asset$2, _image$fields3, _image$fields4, _image$fields5, _image$fields6, _image$fields7, _rendition$fields, _rendition$fields2, _image$fields8, _image$fields9;

    var assetId = image == null ? void 0 : (_image$fields = image.fields) == null ? void 0 : _image$fields.assetId;
    var contentImageId = image == null ? void 0 : (_image$fields2 = image.fields) == null ? void 0 : (_image$fields2$asset = _image$fields2.asset) == null ? void 0 : (_image$fields2$asset$ = _image$fields2$asset.fields) == null ? void 0 : (_image$fields2$asset$2 = _image$fields2$asset$.file) == null ? void 0 : _image$fields2$asset$2.url;
    var alt = image == null ? void 0 : (_image$fields3 = image.fields) == null ? void 0 : _image$fields3.alternateText;
    var isPreload = (_image$fields4 = image.fields) == null ? void 0 : _image$fields4.isPreload;
    var isBannerImage = (_image$fields5 = image.fields) == null ? void 0 : _image$fields5.isBannerImage;
    var isProductPage = (_image$fields6 = image.fields) == null ? void 0 : _image$fields6.isProductPage;
    var rendition = (_image$fields7 = image.fields) == null ? void 0 : _image$fields7.imageRendition;
    var aspectRatio = rendition == null ? void 0 : (_rendition$fields = rendition.fields) == null ? void 0 : _rendition$fields.aspectRatio;
    var transformations = rendition == null ? void 0 : (_rendition$fields2 = rendition.fields) == null ? void 0 : _rendition$fields2.transformations;
    var customClassName = (_image$fields8 = image.fields) == null ? void 0 : _image$fields8.classNames;
    var format = ((_image$fields9 = image.fields) == null ? void 0 : _image$fields9.forcedFormat) || 'auto';
    var alignmentClassName = props.className;
    var resetImage = props.resetImage;
    var product = _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_15__/* .ImageConstants.product */ .j6.product;

    if (props.zoneClassName) {
      if (!customClassName) {
        customClassName = '';
      }

      customClassName += props.zoneClassName;
    }

    return children || props.forceBackground ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(react__WEBPACK_IMPORTED_MODULE_13__.Suspense, {
      fallback: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_16__["default"], {}),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(BackgroundImage, _objectSpread(_objectSpread({}, props), {}, {
        imageId: assetId,
        alt: alt ? alt : noAltText ? '' : 'product',
        contentImageId: contentImageId,
        isPreload: isPreload,
        isBannerImage: isBannerImage,
        widthToHeightRatio: aspectRatio,
        transformations: transformations,
        customClassName: customClassName,
        backgroundPosition: props.backgroundPosition,
        backgroundOffsetTop: props.backgroundOffsetTop,
        alignmentClassName: alignmentClassName,
        format: format,
        assetX: props.assetX,
        assetY: props.assetY,
        customStyles: customStyles,
        hasAssetParallax: props.hasAssetParallax,
        ariaHidden: ariaHidden,
        preloadImage: props.preloadImage,
        desktopBackgroundImage: props.desktopBackgroundImage,
        mobileBackgroundImage: props.mobileBackgroundImage,
        children: children
      }))
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(react__WEBPACK_IMPORTED_MODULE_13__.Suspense, {
      fallback: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_16__["default"], {}),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(Img, _objectSpread(_objectSpread({}, props), {}, {
        scale: scale,
        imageId: assetId,
        contentImageId: contentImageId,
        isPreload: isPreload,
        isBannerImage: isBannerImage,
        isProductPage: isProductPage,
        elemId: elemId,
        alt: altText ? altText : alt !== altText && !noAltText ? "".concat(alt, " ").concat(text ? text : '') : '',
        widthToHeightRatio: aspectRatio,
        transformations: transformations,
        offsetTop: props.offsetTop,
        offsetRight: props.offsetRight,
        offsetBottom: props.offsetBottom,
        offsetLeft: props.offsetLeft,
        customClassName: customClassName,
        alignmentClassName: alignmentClassName,
        format: format,
        resetImage: resetImage,
        ariaHidden: ariaHidden,
        imageClassName: props.imageClassName
      }))
    });
  } else {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(react__WEBPACK_IMPORTED_MODULE_13__.Fragment, {
      children: children
    });
  }
}

/***/ })

}]);